import { render, staticRenderFns } from "./RosQuickStart.vue?vue&type=template&id=15da7154&scoped=true&"
import script from "./RosQuickStart.vue?vue&type=script&lang=js&"
export * from "./RosQuickStart.vue?vue&type=script&lang=js&"
import style0 from "./RosQuickStart.vue?vue&type=style&index=0&id=15da7154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15da7154",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15da7154')) {
      api.createRecord('15da7154', component.options)
    } else {
      api.reload('15da7154', component.options)
    }
    module.hot.accept("./RosQuickStart.vue?vue&type=template&id=15da7154&scoped=true&", function () {
      api.rerender('15da7154', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/monitoring/RosQuickStart.vue"
export default component.exports